/* DOOD - comportements du prototype, portes sur Shopify */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var pad = function (n) { return n < 10 ? '0' + n : '' + n; };

  /* ---------- Formatage monétaire : suit le format de la boutique ---------- */
  var MONEY_FORMAT = document.body.getAttribute('data-money-format') || '{{amount}} €';

  function withDelimiters(cents, precision, thousands, decimal) {
    if (isNaN(cents) || cents === null) return '0';
    var n = (cents / 100.0).toFixed(precision);
    var parts = n.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return whole + (parts[1] ? decimal + parts[1] : '');
  }

  function money(cents) {
    var re = /\{\{\s*(\w+)\s*\}\}/;
    var m = MONEY_FORMAT.match(re);
    if (!m) return withDelimiters(cents, 2, ' ', ',') + ' €';
    var value;
    switch (m[1]) {
      case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2, ',', '.');
    }
    return MONEY_FORMAT.replace(re, value);
  }

  /* ---------- Barre d'annonce : compte a rebours ---------- */
  function countdown() {
    var el = $('[data-countdown]');
    if (!el) return;
    var h = $('[data-cd-h]', el), m = $('[data-cd-m]', el), s = $('[data-cd-s]', el);
    if (!h || !m || !s) return;
    var left = parseInt(el.getAttribute('data-countdown'), 10) || 0;
    var key = 'dood_deadline';
    var stored = null;
    try { stored = sessionStorage.getItem(key); } catch (e) { }
    var deadline = stored ? parseInt(stored, 10) : Date.now() + left * 1000;
    if (!stored) { try { sessionStorage.setItem(key, String(deadline)); } catch (e) { } }

    function tick() {
      var secs = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
      h.textContent = pad(Math.floor(secs / 3600));
      m.textContent = pad(Math.floor((secs % 3600) / 60));
      s.textContent = pad(secs % 60);
      if (secs > 0) setTimeout(tick, 1000);
    }
    tick();
  }

  /* ---------- Header : burger + recherche ---------- */
  function header() {
    var burger = $('[data-burger]'), nav = $('[data-nav]');
    var sBtn = $('[data-search-toggle]'), sBox = $('[data-search-box]');
    if (burger && nav) {
      burger.addEventListener('click', function () {
        var open = nav.classList.toggle('open');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
    if (sBtn && sBox) {
      sBtn.addEventListener('click', function () {
        var open = sBox.classList.toggle('open');
        sBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) { var f = $('input[name="q"]', sBox); if (f) f.focus(); }
      });
    }
  }

  /* ---------- FAQ : accordeon exclusif ---------- */
  function faq() {
    var items = $$('[data-faq] .faq-item');
    items.forEach(function (item, i) {
      var btn = $('.faq-q', item);
      if (!btn) return;
      if (i === 0) { item.classList.add('open'); btn.setAttribute('aria-expanded', 'true'); }
      btn.addEventListener('click', function () {
        var wasOpen = item.classList.contains('open');
        items.forEach(function (o) {
          o.classList.remove('open');
          var b = $('.faq-q', o); if (b) b.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) { item.classList.add('open'); btn.setAttribute('aria-expanded', 'true'); }
      });
    });
  }

  /* ---------- Carrousel d'avis ---------- */
  function reviews() {
    var root = $('[data-revs]');
    if (!root) return;
    var track = $('.revs-track', root);
    var cards = $$('.rev', track);
    if (!cards.length) return;
    var prev = $('[data-rev-prev]'), next = $('[data-rev-next]');
    var i = 0;

    function render() {
      var cs = getComputedStyle(track);
      var gap = parseInt(cs.columnGap || cs.gap, 10) || 28;
      var step = cards[0].getBoundingClientRect().width + gap;
      track.style.transform = 'translateX(' + (-i * step) + 'px)';
      cards.forEach(function (c, k) {
        c.classList.remove('active', 'near');
        if (k === i) c.classList.add('active');
        else if (Math.abs(k - i) === 1) c.classList.add('near');
      });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === cards.length - 1;
    }
    if (prev) prev.addEventListener('click', function () { if (i > 0) { i--; render(); } });
    if (next) next.addEventListener('click', function () { if (i < cards.length - 1) { i++; render(); } });
    window.addEventListener('resize', render);
    render();
  }

  /* ---------- Comment ca marche : puces ---------- */
  function steps() {
    var root = $('[data-steps]');
    if (!root) return;
    var items = $$('.step', root), dots = $$('[data-steps-dots] button');
    function show(k) {
      items.forEach(function (s, j) { s.classList.toggle('on', j === k); });
      dots.forEach(function (d, j) {
        d.classList.toggle('on', j === k);
        d.setAttribute('aria-selected', j === k ? 'true' : 'false');
      });
    }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); }); });
    show(0);
  }

  /* ---------- Fiche produit : selecteur de taille ---------- */
  function product() {
    var root = $('[data-pdp]');
    if (!root) return;
    var idInput = $('[data-variant-id]', root);
    var btns = $$('.size', root);
    var priceEl = $('[data-pdp-price]', root);
    var oldEl = $('[data-pdp-old]', root);
    var saleEl = $('[data-pdp-sale]', root);
    var addBtn = $('[data-add]', root);

    function select(btn) {
      if (btn.classList.contains('out')) return;
      btns.forEach(function (b) { b.classList.remove('on'); b.setAttribute('aria-pressed', 'false'); });
      btn.classList.add('on');
      btn.setAttribute('aria-pressed', 'true');
      if (idInput) idInput.value = btn.getAttribute('data-vid');
      var p = parseInt(btn.getAttribute('data-price'), 10);
      var c = parseInt(btn.getAttribute('data-compare'), 10) || 0;
      if (priceEl && !isNaN(p)) priceEl.textContent = money(p);
      if (oldEl) {
        if (c > p) { oldEl.textContent = money(c); oldEl.hidden = false; }
        else oldEl.hidden = true;
      }
      if (saleEl) {
        if (c > p) {
          saleEl.textContent = '● SOLDES -' + Math.round((c - p) * 100 / c) + '%';
          saleEl.hidden = false;
        } else saleEl.hidden = true;
      }
      if (addBtn) {
        var avail = btn.getAttribute('data-available') === 'true';
        addBtn.disabled = !avail;
        addBtn.textContent = avail ? 'AJOUTER AU PANIER' : 'RUPTURE DE STOCK';
      }
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { select(b); }); });
    var first = btns.filter(function (b) { return !b.classList.contains('out'); })[0];
    if (first) select(first);

    $$('.pdp-thumbs img', root).forEach(function (t) {
      t.addEventListener('click', function () {
        var main = $('[data-pdp-main]', root);
        if (main) { main.src = t.getAttribute('data-full') || t.src; main.alt = t.alt; }
      });
    });
  }

  /* ---------- Panier : stepper + recalcul ---------- */
  function cart() {
    var root = $('[data-cart]');
    if (!root) return;

    function refresh(state) {
      (state.items || []).forEach(function (item) {
        var line = $('[data-key="' + item.key + '"]', root);
        if (!line) return;
        var tot = $('[data-line-total]', line);
        if (tot) tot.textContent = money(item.final_line_price);
        var inp = $('input', line);
        if (inp) inp.value = item.quantity;
      });
      var sub = $('[data-subtotal]', root); if (sub) sub.textContent = money(state.items_subtotal_price);
      var tot = $('[data-total]', root); if (tot) tot.textContent = money(state.total_price);
      var cnt = $('[data-cart-count-label]', root);
      if (cnt) cnt.textContent = state.item_count + (state.item_count > 1 ? ' articles' : ' article');
      $$('[data-cart-bubble]').forEach(function (b) { b.textContent = state.item_count; });
      if (state.item_count === 0) window.location.reload();
    }

    function change(key, qty) {
      root.setAttribute('aria-busy', 'true');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(refresh)
        .catch(function () { window.location.reload(); })
        .then(function () { root.removeAttribute('aria-busy'); });
    }

    $$('[data-key]', root).forEach(function (line) {
      var key = line.getAttribute('data-key');
      var inp = $('input', line);
      var minus = $('[data-minus]', line), plus = $('[data-plus]', line);
      var rm = $('[data-remove]', line);
      if (minus) minus.addEventListener('click', function () {
        var v = Math.max(1, parseInt(inp.value, 10) - 1); inp.value = v; change(key, v);
      });
      if (plus) plus.addEventListener('click', function () {
        var v = parseInt(inp.value, 10) + 1; inp.value = v; change(key, v);
      });
      if (inp) inp.addEventListener('change', function () {
        var v = Math.max(1, parseInt(inp.value, 10) || 1); inp.value = v; change(key, v);
      });
      if (rm) rm.addEventListener('click', function (e) { e.preventDefault(); change(key, 0); });
    });

    var timer = $('[data-hold-timer]', root);
    if (timer) {
      var key2 = 'dood_hold';
      var stored = null;
      try { stored = sessionStorage.getItem(key2); } catch (e) { }
      var end = stored ? parseInt(stored, 10) : Date.now() + 600000;
      if (!stored) { try { sessionStorage.setItem(key2, String(end)); } catch (e) { } }
      (function tick() {
        var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
        timer.textContent = pad(Math.floor(s / 60)) + ':' + pad(s % 60);
        if (s > 0) setTimeout(tick, 1000);
      })();
    }
  }

  /* ---------- Date de livraison estimee (jours ouvres) ---------- */
  function delivery() {
    $$('[data-delivery]').forEach(function (el) {
      var days = parseInt(el.getAttribute('data-delivery'), 10) || 4;
      var d = new Date();
      while (days > 0) {
        d.setDate(d.getDate() + 1);
        var wd = d.getDay();
        if (wd !== 0 && wd !== 6) days--;
      }
      try {
        el.textContent = d.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
      } catch (e) {
        el.textContent = d.toLocaleDateString();
      }
    });
  }

  function init() {
    countdown(); header(); faq(); reviews(); steps(); product(); cart(); delivery();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
